
import {
  BASE_URL_4,
  instance4,
} from "App/constants";
import { DEFAULT_BOX_SHADOW, PRIMARY_BACKGROUND } from "App/constants/theme";
import { makeStyles } from "@material-ui/core/styles";
import moment from "moment";
import fileDownload from "js-file-download";
import { MasterButton } from "App/Component/ui";
import { getIDunit, getNamaUnit, getUserName } from "App/utils/cookies";
import { isNull } from "App/utils/helpers";

export const urlCreateREQ = "/wmsAsset/helpdesk/add-header";
export const urlUpdateREQ = "/wmsAsset/helpdesk/update-header";
export const urlGetReqById = "/wmsAsset/helpdesk/list-detail-id";

export const urlVerifikasiBarang = "/wmsAsset/helpdesk/update-status-detail";
export const urlVerifikasiTransaksi = "/wmsAsset/helpdesk/update-status-header";

export const urlGetBarangReqById = "wmsAsset/helpdesk/list-id";

export const STATUS_OPEN_DRAFT = false;
export const STATUS_PROCESS = true;

// Status Validasi Perbarang
export const STATUS_BARANG_PENGAJUAN = 0;
export const STATUS_BARANG_PROSES = 1;
export const STATUS_BARANG_SELESAI = 2;
export const STATUS_BARANG_PENDING = 3;

// Status Transaksi
export const STATUS_PENGERJAAN_DRAFT = 0;
export const STATUS_PENGERJAAN_PENGAJUAN = 1;
export const STATUS_PENGERJAAN_DISETUJUI = 2;
export const STATUS_PENGERJAAN_PENDING = 3;
export const STATUS_PENGERJAAN_PROSES = 4;
export const STATUS_PENGERJAAN_SELESAI = 5;
export const STATUS_PENGERJAAN_REVISI = 101;
export const STATUS_PENGERJAAN_REJECT = 99;

export const status_pengerjaan = [
  {
    label: "DRAFT",
    value: STATUS_PENGERJAAN_DRAFT,
  },
  {
    label: "PENGAJUAN",
    value: STATUS_PENGERJAAN_PENGAJUAN,
  },
  {
    label: "DISETUJUI",
    value: STATUS_PENGERJAAN_DISETUJUI,
  },
  {
    label: "PENDING",
    value: STATUS_PENGERJAAN_PENDING,
  },
  {
    label: "PROSES",
    value: STATUS_PENGERJAAN_PROSES,
  },
  {
    label: "SELESAI",
    value: STATUS_PENGERJAAN_SELESAI,
  },
  {
    label: "REVISI",
    value: STATUS_PENGERJAAN_REVISI,
  },
  {
    label: "REJECT",
    value: STATUS_PENGERJAAN_REJECT,
  },
]

// Status Validasi Pengerjaan

export const STATUS_PERMINTAAN_PENGAJUAN = 0;
export const STATUS_PERMINTAAN_PROSES = 1;
export const STATUS_PERMINTAAN_SELESAI = 2;
export const STATUS_PERMINTAAN_PENDING = 3;

export const STYLE_MASTER_FA = makeStyles({
  root: {
    width: "auto",
  },
  paper: {
    width: "100%",
    margin: "0",
    padding: "1rem 1.5rem",
    backgroundColor: PRIMARY_BACKGROUND,
    boxShadow: DEFAULT_BOX_SHADOW,
  },
  table: {
    width: "100%",
    margin: "0 auto",
    overflow: "auto",
  },
});

export const FORM_RESET_STATE_WMS_RMT = {
  id: "",

  unit_id: isNull(getIDunit()) ? null : getIDunit(),
  unit: isNull(getNamaUnit()) ? "Pilih Unit" : getNamaUnit(),

  gudang_id: null,
  gudang: "Pilih Gudang",

  remark: "",
  remark_recive:"",

  user_request: getUserName(),
  status_request: 0,

  type: "create",
  status: true,

  isOpenDraf: false,
  isProcess: false,
  taggal_request: moment(new Date()).local().toDate(),
  listreq: [],
};

export const FORM_RESET_STATE_DETAIL = {
  id: "",
  fixasset_id: "",
  fixasset_name: "",
  fixasset_code: "",
  remark: "",
};

export const downloadPDF = async (id, fileName) => {
  try {
    const api = await instance4.get(`${BASE_URL_4}/wmsAsset/helpdesk/download-file/${id}`, {
      responseType: "blob",
    });
      fileDownload(api.data, fileName);
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const getReqById = async (id) => {
  try {
    const api = await instance4.get(`${urlGetReqById}/${id}`);
    const res = api.data;
    if (res.status === 200) {
      return {
        state: true,
        data:
          res.data.length > 0
            ? res.data[0]
            : {
                totalTax: 0,
                jumlah: 0,
              },
      };
    } else {
      return {
        state: false,
        message: res.message,
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const getReqListById = async (id) => {
  try {

    const api = await instance4.get(`${urlGetBarangReqById}/${id}`);
    const res = api.data;
    if (res.status === 200) {
      return {
        state: true,
        data: res.data,
      };
    } else {
      return {
        state: false,
        message: res.message,
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "center",
  },
  {
    id: "id",
    disablePadding: true,
    label: "ID",
    align: "left",
  },
  {
    id: "nama_asset",
    disablePadding: false,
    label: "NAMA BARANG",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "file_name",
    disablePadding: false,
    label: "FILE",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "remark",
    disablePadding: false,
    label: "CATATAN",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "status_request",
    disablePadding: false,
    label: "STATUS",
    align: "left",
  },
  {
    id: "remark_status",
    disablePadding: false,
    label: "CATATAN PERMINTAAN",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "status_cek_barang",
    disablePadding: false,
    label: "STATUS",
    align: "center",
    minWidth: "80px",
  },
  {
    id: "keterangan_cek_barang",
    disablePadding: false,
    label: "KETERANGAN",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "kategori",
    disablePadding: false,
    label: "KATEGORI BARANG",
    align: "left",
    minWidth: "80px",
  },
  {
    id: "user_cek_barang",
    disablePadding: false,
    label: "PEMERIKSA",
    align: "left",
    minWidth: "100px",
  },
  {
    id: "dateCek",
    disablePadding: false,
    label: "TGL CEK",
    align: "left",
    minWidth: "100px",
  },
];

export const RenderStatusVerifikasiBadgePermintaan = ({ status }) => { // eslint-disable-line
  if (status === STATUS_PERMINTAAN_PENGAJUAN) {
    return (
      <MasterButton
        style={{ borderRadius: 20 }}
        name={"PENGAJUAN"}
        color={"secondary"}
        type='button'
        disabled
      />
    );
  } else if (status === STATUS_PERMINTAAN_PROSES) {
    return (
      <MasterButton
        style={{ borderRadius: 20 }}
        name={"PROSES"}
        color={"lightgreen"}
        type='button'
        disabled
      />
    );
  } else if (status === STATUS_PERMINTAAN_SELESAI) {
    return (
      <MasterButton
        style={{ borderRadius: 20 }}
        name={"SELESAI"}
        color={"green"}
        type='button'
        disabled
      />
    );
  } else if (status === STATUS_PERMINTAAN_PENDING) {
    return (
      <MasterButton
        style={{ borderRadius: 20 }}
        name={"PENDING"}
        color={"warning"}
        type='button'
        disabled
      />
    );
  } else {
    return <p>-</p>;
  }
};




